import Vue from 'vue'

const ENDPOINT = '/notifications'
const FLASK_ENDPOINT = `${process.env.VUE_APP_FLASK_URL}/api/users`

export default {
  get (page, perPage) {
    return Vue.prototype.$http.get(`${ENDPOINT}?page=${page}&per_page=${perPage}`).then(response => response.data)
  },
  update (ids) {
    return Vue.prototype.$http.put(`${ENDPOINT}`, { notification: { ids: ids } }).then(response => response.data)
  },
  unread () {
    return Vue.prototype.$httpSilentError.post(`${FLASK_ENDPOINT}/unread`, {}).then(response => response.data)
  }
}
